import { useEffect, useState } from "react";
import {
  Autocomplete,
  Card,
  CardHeader,
  Checkbox,
  DatePicker,
  DatePickerMui,
  FormControl,
  FormControlLabel,
  Grid,
  MenuItem,
  Select,
  TextField,
} from "../../../../../components";
import { value } from "../../../../../helpers";
import { responseErros } from "../../../../../utils";
import { contextosLote } from "../../../resources/constantes";
import { useFiltrosHandlers } from "./use-filtros-handler.component";
import { TagsService, GrupoPessoasService } from "../../../../../services";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { ptBR } from "date-fns/locale";

export function FiltrosPessoasMensagemLote({
  id,
  filtros,
  setFiltros,
  activeStep,
  inputErros,
  mensagem,
  handleChange,
}) {
  const { onChangeInput, onChangeAutocomplete, onChangeDate } =
    useFiltrosHandlers(setFiltros);
  const [listaTags, setListaTags] = useState([]);
  const [listaGrupoPessoa, setListaGrupoPessoa] = useState([]);
  const tagsService = new TagsService();
  const grupoPessoasService = new GrupoPessoasService();

  useEffect(() => {
    if (activeStep === 0) {
      buscarTags();
      buscaGruposPessoas();
      inserirValoresListaTags(filtros?.tagsId);
    }
  }, [activeStep]);

  function inserirValoresListaTags(listaTagsIds) {
    if (!listaTagsIds?.length) return;
    const idsTags =
      listaTagsIds?.map((id) => ({
        id,
      })) || [];
    setFiltros((prevState) => ({
      ...prevState,
      tagsId: idsTags,
    }));
  }

  const buscarTags = () => {
    const filter = {
      nonPaginated: true,
      ativado: true,
      tipo: "PESSOA",
    };
    tagsService.getAll(filter).then((res) => {
      if (!res.isAxiosError) {
        setListaTags(res.data);
      } else {
        responseErros(res);
      }
    });
  };

  const buscaGruposPessoas = async () => {
    const filtros = {
      ativado: true,
      tipoPessoa: 1,
      restritiva: true,
    };
    const res = await grupoPessoasService.getAllFiltroAvancado(filtros);
    if (!res.isAxiosError) {
      setListaGrupoPessoa(res.data.rows);
    } else {
      responseErros(res);
    }
  };

  const onChangeCheckbox = (event) => {
    setFiltros((prev) => ({
      ...prev,
      sexo: null,
      tagsId: null,
      grupoPessoaId: null,
      [event.target.name]: event.target.checked ?? null,
    }));
  };

  const onChangeDateBirthday = (date) => {
    if (!date) return;

    const inicioMes = format(startOfMonth(date), "yyyy-MM-dd");
    const fimMes = format(endOfMonth(date), "yyyy-MM-dd");

    setFiltros((prev) => ({
      ...prev,
      dataNascimentoStart: inicioMes,
      dataNascimentoEnd: fimMes,
      dataReferenciaMes: date,
    }));
  };

  const getMultipleAutocompleteValues = (valores, lista) => {
    if (valores) {
      return valores.map((valor) => value.autoComplete(lista, valor.id));
    }
    return [];
  };

  function filtrosData() {
    let data = new Date();
    data.setDate(data.getDate() + 1);
    switch (mensagem?.contexto) {
      case "aniversario":
        return (
          <Grid item xs={4}>
            <DatePickerMui
              label="Mês de Referência"
              views={["month"]}
              openTo="month"
              margin
              value={filtros?.dataReferenciaMes}
              onChange={(date) => onChangeDateBirthday(date)}
              format="MMMM/yyyy"
              localeText={{ toolbarTitle: "Escolha o mês" }}
              slotProps={{
                textField: { fullWidth: true },
              }}
              locale={ptBR}
            />
          </Grid>
        );
      case "condicional-cobranca":
      case "condicional-lembrete":
        return (
          <>
            <Grid item xs={4}>
              <DatePicker
                id="dataVencimentoStart"
                name="Data-Vencimento-Condicional-De"
                label="Data Vencimento Condicional De"
                margin
                format="dd/MM/yyyy"
                maxDate={mensagem?.contexto.endsWith("cobranca") && new Date()}
                minDate={mensagem?.contexto.endsWith("lembrete") && data}
                value={value.date(filtros?.dataVencimentoStart)}
                onChange={(date) => onChangeDate("dataVencimentoStart", date)}
                error={inputErros.get("dataVencimentoStart")}
              />
            </Grid>
            <Grid item xs={4}>
              <DatePicker
                id="dataVencimentoEnd"
                name="Data-Vencimento-Condicional-Até"
                label="Data Vencimento Condicional Até"
                margin
                format="dd/MM/yyyy"
                maxDate={mensagem?.contexto.endsWith("cobranca") && new Date()}
                minDate={mensagem?.contexto.endsWith("lembrete") && data}
                value={value.date(filtros?.dataVencimentoEnd)}
                onChange={(date) => onChangeDate("dataVencimentoEnd", date)}
                error={inputErros.get("dataVencimentoEnd")}
              />
            </Grid>
          </>
        );
      case "conta-receber-cobranca":
      case "conta-receber-lembrete":
        return (
          <>
            <Grid item xs={4}>
              <DatePicker
                id="dataVencimentoStart"
                name="Data-Vencimento-Contas-Receber-De"
                label="Data Vencimento Contas Receber De"
                margin
                format="dd/MM/yyyy"
                maxDate={mensagem?.contexto.endsWith("cobranca") && new Date()}
                minDate={mensagem?.contexto.endsWith("lembrete") && data}
                value={value.date(filtros?.dataVencimentoStart)}
                onChange={(date) => onChangeDate("dataVencimentoStart", date)}
              />
            </Grid>
            <Grid item xs={4}>
              <DatePicker
                id="dataVencimentoEnd"
                name="Data-Vencimento-Contas-Receber-Até"
                label="Data Vencimento Contas Receber Até"
                margin
                format="dd/MM/yyyy"
                maxDate={mensagem?.contexto.endsWith("cobranca") && new Date()}
                minDate={mensagem?.contexto.endsWith("lembrete") && data}
                value={value.date(filtros?.dataVencimentoEnd)}
                onChange={(date) => onChangeDate("dataVencimentoEnd", date)}
              />
            </Grid>
          </>
        );
      case "campanha":
        return (
          <>
            <Grid item xs={12} md={4}>
              <Select
                label="Sexo"
                name="sexo"
                id="sexo"
                margin="normal"
                variant="outlined"
                onChange={(e) => onChangeInput(e)}
                value={value.text(filtros?.sexo)}
                InputLabelProps={{ shrink: true }}
                error={inputErros.get("sexo")}
              >
                <MenuItem value={"masculino"}>Masculino</MenuItem>
                <MenuItem value={"feminino"}>Feminino</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} md={4}>
              <FormControl variant="outlined" fullWidth>
                <Autocomplete
                  multiple
                  id="tagsId"
                  name="tagsId"
                  options={listaTags}
                  noOptionsText="Sem opções"
                  autoHighlight
                  renderOption={(props, option) => {
                    return option ? (
                      <li {...props}>
                        <div className="d-flex align-items-center gap-2 w-100">
                          <i
                            className="ph-fill ph-bookmark-simple"
                            style={{ color: option.cor, fontSize: 18 }}
                          />
                          <div>{option.descricao}</div>
                        </div>
                      </li>
                    ) : (
                      ""
                    );
                  }}
                  getOptionLabel={(option) => {
                    return option ? option.descricao : "";
                  }}
                  onChange={(_, newValue) => {
                    setFiltros((prevState) => ({
                      ...prevState,
                      tagsId: newValue,
                    }));
                  }}
                  value={getMultipleAutocompleteValues(
                    filtros?.tagsId,
                    listaTags
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Tags"
                      margin="normal"
                      error={inputErros.get("tagsId")}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <FormControl variant="outlined" fullWidth>
                <Autocomplete
                  id="grupoPessoaId"
                  name="grupoPessoaId"
                  options={listaGrupoPessoa}
                  noOptionsText="Sem opções"
                  autoHighlight
                  getOptionLabel={(option) => (option.nome ? option.nome : "")}
                  filterSelectedOptions
                  onChange={(_, newValue) =>
                    onChangeAutocomplete("grupoPessoaId", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      margin="normal"
                      label="Grupos de Pessoas"
                    />
                  )}
                  value={value.autoComplete(
                    listaGrupoPessoa,
                    filtros?.grupoPessoaId
                  )}
                />
              </FormControl>
            </Grid>
          </>
        );
      default:
        break;
    }
  }

  return (
    <Card className="p-3">
      <CardHeader title="Filtros" />
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Select
            fullWidth
            name="contexto"
            value={mensagem?.contexto}
            onChange={handleChange}
            label="Contexto da Mensagem"
            disabled={id}
            error={inputErros.get("contexto")}
          >
            {contextosLote.map((status, index) => (
              <MenuItem key={index} value={status.value}>
                {status.label}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={8}>
          {mensagem?.contexto !== "aniversario" && (
            <FormControlLabel
              className="mt-2"
              control={
                <Checkbox
                  checked={filtros?.todosClientes}
                  onChange={(e) => onChangeCheckbox(e)}
                  name="todosClientes"
                  color="primary"
                />
              }
              label="Todos os Clientes"
            />
          )}
        </Grid>
        {filtrosData()}
      </Grid>
    </Card>
  );
}
